import "./Footer.css"

export const Footer = () => {
  return (
    <div id="vihari-footer-main-wrapper">
      <div id="footer-logo-section-wrap">
        <div id="footer-logo-section-logo-wrap">
          <img src="./logo01.png" alt="logo" id="footer-logo-section-logo" />
        </div>
        <div id="footer-logo-section-title">VIHARI PROJECTS</div>
      </div>
      <div id="footer-section-content-wrapper">
        <div>
          <div id="footer-address-section-wrap">
            <div id="footer-address-section-title">Address</div>
            <div id="footer-address-section-content">
              Plot No. 227, Surya Meadows, S Rd Number 9, near to Astalaxmi
              Temple, Kothapet, Hyderabad, Telangana 500035
            </div>
          </div>

          <div id="footer-map-direction-section-wrap">
            <div id="footer-map-direction-section-title">Map & Directions</div>
          </div>
        </div>
        <div>
          <div id="footer-contact-section-wrap">
            <div id="footer-contact-section-title">Contact & Email</div>
            <div className="footer-contact-section-content">
              (91) – 8121756666
            </div>
            <div className="footer-contact-section-content">
              (91) – 9294929929
            </div>
          </div>

          <div id="footer-contact-section-mail">vihariprojects@gmail.com</div>
        </div>
      </div>
      <div id="footer-copyright-section">
        © 2023 Vihari Project - Website by Ray Formula
      </div>

      <div id="footer-bottom-color-block"></div>
    </div>
  );
}